<template>
    <div class="m-gallery-hub">
        <div class="m-module-header coaching-container" data-fwk-module="ModuleHeader">

            <div class="s-coaching-filters coaching-container-filters">
                <div class="coaching-loader" v-show="isLoading"></div>

                <div class="coaching-title coaching-title-filters">
                    Filter
                </div>

                <div class="s-coaching-filters-mobile-btn" v-on:click="toggleFilters">
                    <div class="s-filters-btn__icon">
                        <div class="s-line">
                            <div class="s-round"></div>
                        </div>
                        <div class="s-line">
                            <div class="s-round"></div>
                        </div>
                        <div class="s-line">
                            <div class="s-round"></div>
                        </div>
                    </div>
                    <div class="s-filters-btn__title">Filter</div>
                </div>

                <div class="coaching-filter-box-wrapper">
                    <div class="coaching-filter-close-btn" v-on:click="closeFilters"></div>

                    <div class="coaching-filter-box">
                        <span class="coaching-filter-box-title">Level</span>
                        <div class="coaching-filter-box-item" v-for="filter in mediaFilters.LevelFilters"
                             :key="filter.LevelID" id="levelFilters">
                            <input type="checkbox" :id="filter.LevelName" :value="filter.LevelID"
                                   v-model="filters.level"
                                   v-on:change="filtersChanged" name="levelFilters">
                            <label :for="filter.LevelName">{{ filter.LevelName }}</label>
                        </div>
                    </div>

                    <div class="coaching-filter-box">
                        <span class="coaching-filter-box-title">Type</span>
                        <div class="coaching-filter-box-item" v-for="filter in mediaFilters.TypeFilters"
                             :key="filter.TypeID" id="typeFilters">
                            <input type="checkbox" :id="filter.TypeFiltername" :value="filter.TypeID"
                                   v-model="filters.type"
                                   v-on:change="filtersChanged" name="typeFilters">
                            <label :for="filter.TypeFiltername">{{ filter.TypeFiltername }}</label>
                        </div>
                    </div>

                    <div class="coaching-filter-box">
                        <span class="coaching-filter-box-title">Drill</span>
                        <div class="coaching-filter-box-item" v-for="filter in mediaFilters.DrillFilters"
                             :key="filter.NodeID" id="drillFilters">
                            <input type="checkbox" :id="filter.NodeID" :value="filter.NodeID" v-model="filters.drills"
                                   v-on:change="filtersChanged" name="drillFilters">
                            <label :for="filter.NodeID">{{ filter.DrillCategoryName }}</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="s-cards coaching-container-items">
                <div class="coaching-title coaching-title-items">Media</div>
                <div class="s-cards__inner">
                    <div class="b-card  b-card--video" v-for="video in mediaItems" :key="video.NodeID">
                        <div class="s-image-container">
                            <a :href="video.DetailUrl" class="s-image"
                               :style="{'backgroundImage': 'url(' + video.MediaThumbnail.replace(' ', '%20') + ')'}"></a>
                            <div class="s-main-tag">
                                <span class="s-tag ">
                                       <span v-if="video.MediaType === 0" class="s-tag-link"
                                             :style="{ 'backgroundColor': '#3bace3'} ">Beginner</span>
                                    <span v-if="video.MediaType === 1" class="s-tag-link"
                                          :style="{ 'backgroundColor': '#6e6e6e'} ">Intermediate</span>
                                    <span v-else-if="video.MediaType === 2" class="s-tag-link"
                                          :style="{ 'backgroundColor': '#000000'} ">Advanced</span>
                                </span>
                            </div>
                        </div>

                        <div class="s-text-container">
                            <div class="s-title">{{ video.Title }}</div>
                            <div class="s-text">{{ video.ShortDescription }}</div>
                        </div>
                    </div>
                </div>

                <div class="s-cards__more" v-show="showShowMoreButton">
                    <a href="#" class="s-more" v-on:click="loadMore">show more</a>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: 'CoachingComponent',
        data: function () {
            return {
                filters: {
                    level: [],
                    type: [],
                    drills: []
                },
                mediaFilters: [],
                mediaItems: [],
                itemsDisplaying: 9,
                showShowMoreButton: true,
                showMoreTake: 9,
                isLoading: false
            }
        },
        mounted() {
            //if running locally
            // let recaptchaScript = document.createElement('script');
            // recaptchaScript.setAttribute('src', 'http://iihf.devweb13.emakina.at/App_Themes/Emakina/scripts/app.js');
            // document.head.appendChild(recaptchaScript);
            this.setFilters();
            this.callAPI();
        },
        methods: {
            loadMore: function (e) {
                e.preventDefault();
                this.itemsDisplaying = this.itemsDisplaying + this.showMoreTake;
                this.callAPI();
            },
            filtersChanged: function (event) {
                if (event.target.name === "levelFilters") {
                    this.filters.type = [];
                    this.filters.drills = [];
                } else if (event.target.name === "typeFilters") {
                    this.filters.drills = [];
                }

                const urlParams = '?level=' + this.filters.level.toString() + '&type=' + this.filters.type.toString() + '&dril=' + this.filters.drills.toString();
                history.pushState(null, null, urlParams)

                this.callAPI();
            },
            setFilters: function () {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                const level = urlParams.get('level');
                const type = urlParams.get('type');
                const drill = urlParams.get('dril');

                if (level !== undefined && level !== null) {
                    this.filters.level = JSON.parse("[" + level + "]")
                }
                if (type !== undefined && type !== null) {
                    this.filters.type = JSON.parse("[" + type + "]")
                }
                if (drill !== undefined && drill !== null) {
                    this.filters.drills = JSON.parse("[" + drill + "]")
                }

            },
            callAPI: function () {
                this.isLoading = true;
                //if running locally change url to http://iihf.devweb13.emakina.at/coaching/media
                //if running live change url to /coaching/media
                axios.post('/coaching/media', {
                    Take: this.itemsDisplaying,
                    SelectedDrillLevels: this.filters.level,
                    SelectedDrillTypes: this.filters.type,
                    SelectedDrillCategories: this.filters.drills
                }).then((response) => {
                    this.mediaFilters = response.data.MediaFilters;
                    this.mediaItems = response.data.MediaItems;
                    this.isLoading = false;
                    this.showShowMoreButton = response.data.HasMoreResults;
                });
            },
            toggleFilters: function () {
                let windowWidth = window.outerWidth;
                let filtersWrapper = document.querySelector('.coaching-filter-box-wrapper');
                let filtersWrapperIsOpen = filtersWrapper.classList.contains('is-expanded');

                if (windowWidth <= 1550) {
                    if (filtersWrapperIsOpen) {
                        filtersWrapper.classList.remove('is-expanded');
                    } else {
                        filtersWrapper.classList.add('is-expanded');
                    }
                }
            },
            closeFilters: function () {
                let filtersWrapper = document.querySelector('.coaching-filter-box-wrapper');
                filtersWrapper.classList.remove('is-expanded');
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="scoped" lang="less">
    .coaching-container {
        display: flex;
        box-sizing: border-box;

        @media all and (max-width: 1550px) {
            flex-direction: column;
        }

        &-filters {
            flex: 1;
            position: relative;

            @media all and (max-width: 1550px) {
                padding: 0 30*(100/1550px) * 1vw;
                cursor: pointer;
            }
        }

        &-items {
            flex: 5;
        }
    }

    .coaching-title {
        text-transform: uppercase;
        color: #002d62;
        font-family: SourceSansPro-Black;
        margin-bottom: 46px;
        position: relative;

        @media all and (max-width: 1550px) {
            margin-bottom: 14px;
        }

        &-filters {
            font-size: 16px;
            margin-top: 9%;

            @media all and (max-width: 1550px) {
                display: none;
            }
        }

        &-items {
            font-size: 32px;
        }
    }

    .coaching-filter-box-wrapper {
        @media all and (max-width: 1550px) {
            max-height: 0;
            overflow: hidden;

            &.is-expanded {
                position: fixed;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                padding: 60px 40px 40px;
                max-height: 10000px;
                z-index: 9000;
                background: #fff;
                overflow: scroll;

                .coaching-filter-close-btn {
                    display: block;
                }
            }
        }
    }

    .coaching-filter-box {
        width: 90%;
        text-transform: uppercase;
        color: #002d62;
        font-family: SourceSansPro-Black;
        border: 1px solid #b4b4b4;
        margin-bottom: 15%;
        position: relative;
        padding: 10px 7px 10px 5px;
        box-sizing: border-box;
        font-size: 15px;

        @media all and (max-width: 1550px) {
            width: 100%;
            margin-bottom: 30px;
        }

        &-title {
            font-size: 12px;
            color: #949494;
            position: absolute;
            top: -14px;
            margin-left: 2px;
            padding: 5px;
            background-color: #f4f4f4;
        }

        &-item {
            padding: 5px;

            > input[type=checkbox] {
                -webkit-appearance: none;
                background-color: #fafafa;
                border: 2px solid #4593ce;
                padding: 8px;
                border-radius: 3px;
                display: inline-block;
                position: relative;

                &:checked {
                    background-color: #e9ecee;
                    color: #4593ce;

                    &:after {
                        content: '\2610';
                        font-size: 8px;
                        position: absolute;
                        top: 2px;
                        left: 2px;
                        right: 2px;
                        bottom: 2px;
                        background: #4593ce;
                    }
                }
            }

            > label {
                padding-left: 6px;
            }
        }
    }

    .coaching-loader {
        opacity: 0.4;
        width: 100%;
        height: 100%;
        z-index: 10000;
        position: absolute;
        background-color: #f4f4f4;
        left: 0;
        top: 0;
    }

    .s-coaching-filters-mobile-btn {
        display: none;
        justify-content: flex-end;
        margin: 30px 0;
        width: 100%;

        @media all and (max-width: 1550px) {
            display: flex;
        }
    }

    .coaching-filter-close-btn {
        display: none;

        @media all and (max-width: 1550px) {
            position: absolute;
            top: 10px;
            right: 10px;
            width: 60px;
            height: 60px;

            &:before {
                content: "";
                display: block;
                position: absolute;
                background: #979797;
                top: 50%;
                left: 50%;
                transform: translateX(-50%) translateY(-50%) rotate(-45deg);
                width: 30px;
                height: 1px;
            }

            &:after {
                content: "";
                display: block;
                position: absolute;
                background: #979797;
                top: 50%;
                left: 50%;
                transform: translateX(-50%) translateY(-50%) rotate(45deg);
                width: 30px;
                height: 1px;
            }
        }
    }

</style>